module.exports = __webpack_public_path__ + "img/logo-wework@3x.d0178f9c.png";